import React, { useState, useEffect } from "react";

const TabbedFormComponent = ({ formContent, dataTableComponent }) => {
  const [activeTab, setActiveTab] = useState("form");
  const [isDataTableVisible, setIsDataTableVisible] = useState(false);

  // Effect to load the table only when "LIST" tab is clicked
  useEffect(() => {
    if (activeTab === "datatable" && !isDataTableVisible) {
      // Load the data table
      setIsDataTableVisible(true);
    }
  }, [activeTab, isDataTableVisible]);

  // Function to switch to "form" tab when editing a client
  const switchToFormTab = () => {
    setActiveTab("form");
  };

  return (
    <div className="container mx-auto p-6">
      {/* Tab Navigation */}
      <div className="flex border-b">
        <button
          className={`px-4 py-2 ${
            activeTab === "form" ? "border-b-2 border-blue-500 text-blue-500" : "text-gray-500"
          }`}
          onClick={() => setActiveTab("form")}
        >
          ADD
        </button>
        <button
          className={`px-4 py-2 ${
            activeTab === "datatable" ? "border-b-2 border-blue-500 text-blue-500" : "text-gray-500"
          }`}
          onClick={() => setActiveTab("datatable")}
        >
          LIST
        </button>
      </div>

      {/* Tab Content */}
      <div className="mt-4">
        {activeTab === "form" && <div>{formContent(switchToFormTab)}</div>}
        {activeTab === "datatable" && isDataTableVisible && (
          <div>
            {dataTableComponent(switchToFormTab)}
          </div>
        )}
      </div>
    </div>
  );
};

export default TabbedFormComponent;
